// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bar[data-v-1fbee8bc]{width:100%;height:15px;border-radius:7.5px;overflow:hidden;position:relative}.bar .indicator[data-v-1fbee8bc]{height:100%}.bar .slice[data-v-1fbee8bc]{position:absolute;top:0;bottom:0;width:1px;background-color:var(--body-bg)}", ""]);
// Exports
module.exports = exports;
